import { Command } from 'cmdk';
import { useMemo } from 'react';

import { generateCommandBarProvidersList } from '../command-bar-utils.js';

import type { CommandBarProviderConfig, CommandBarProviderProps } from '../command-bar-types.js';

interface GroupProviderProps extends CommandBarProviderProps {
	heading: React.ReactNode;
	providers: CommandBarProviderConfig<any>[];
}

export function CommandBarGroupProvider({ heading, providers, onClose, search }: GroupProviderProps) {
	const sortedProviders = useMemo(() => {
		return generateCommandBarProvidersList(search, providers);
	}, [search, providers]);

	return (
		<Command.Group heading={heading}>
			{sortedProviders.map((provider) => {
				const Component = provider.component;
				return <Component key={provider.id} {...provider.props} onClose={onClose} search={search} />;
			})}
		</Command.Group>
	);
}
